<template>
  <el-dialog title="生成条形码" :visible.sync="dialogVisible" width="30%" @close="handleClose">
    <el-form :model="barcodeForm" label-width="100px">
      <el-form-item label="条形码内容">
        <el-input v-model="barcodeForm.content" placeholder="请输入条形码内容"></el-input>
      </el-form-item>
      <el-form-item label="条码类型">
        <el-select v-model="barcodeForm.type" placeholder="请选择条码类型">
          <el-option v-for="item in barcodeTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="字体大小">
        <el-input-number v-model="barcodeForm.fontSize" :min="6" :max="24" :step="1"></el-input-number>
      </el-form-item>
      <el-form-item label="条形码宽度">
        <el-input-number v-model="barcodeForm.width" :min="50" :max="300" :step="10"></el-input-number>
      </el-form-item>
      <el-form-item label="条形码高度">
        <el-input-number v-model="barcodeForm.height" :min="30" :max="150" :step="10"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleGenerate">生成</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { barcodeTypes } from '../optionData.js';
export default {
  name: 'BarcodeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    barcodeForm: {
      type: Object,
      default: () => ({
        content: '',
        width: 200,
        height: 80,
        type: 'CODE128',
        fontSize: 12
      })
    },

  },
  data() {
    return {
      barcodeTypes,
      dialogVisible: this.visible
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
      },
      immediate: true
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal);
    }
  },
  methods: {
    // 生成条形码
    handleGenerate() {
      if (!this.barcodeForm.content) {
        this.$message.warning('请输入条形码内容');
        return;
      }
      // 发送生成事件
      this.$emit('generate');
      // 关闭弹框
      this.dialogVisible = false;
    },

    // 取消操作
    handleCancel() {
      this.dialogVisible = false;
    },
    // 关闭弹框
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped>
/* 弹框样式 */
.dialog-footer {
  text-align: center;
}
</style>